<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12" md="12" sm="12">
        <v-banner icon="mdi-credit-card-outline">Order Payment</v-banner>
        <v-card flat>
          <v-card-title>
            <v-icon color="primary" class="mr-2">info</v-icon>Please make the payment for your order to be processed
          </v-card-title>
          <v-card-text>
            <span v-if="tdId">Transaction ID : {{tdId}}</span>
            <br />
            <span v-if="orderTotal">Transaction Amount : £ {{parseFloat(orderTotal).toFixed(2)}}</span>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="12">
        <v-card flat>
          <v-form v-model="valid" id="payment-form">
            <v-card-title>
              <v-icon>home</v-icon>
              <span class="subtitle-1 font-weight-bold ml-2">Billing Address</span>
              <v-checkbox v-model="sameAddress" class="ml-3" label="Same as Account"></v-checkbox>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="address.line1"
                outlined
                :rules="[required('Address')]"
                label="Address Line 1"
              ></v-text-field>
              <v-text-field v-model="address.line2" outlined label="Address Line 2"></v-text-field>
              <v-text-field v-model="address.city" outlined label="City"></v-text-field>
              <v-text-field
                v-model="address.postal_code"
                outlined
                :rules="[required('PostCode'), isPostCode]"
                label="PostCode"
              ></v-text-field>
              <v-row v-if="error">
                <v-col cols="12">
                  <v-icon left color="error" class="mr-2">announcement</v-icon>
                  <span class="error--text">{{errorMessage}}</span>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-title>
              <v-icon>payment</v-icon>
              <span class="subtitle-1 font-weight-bold ml-2">Card Details</span>
            </v-card-title>
            <v-card-text>
              <div id="card-element" class="mt-2">
                <!--Stripe.js injects the Card Element-->
              </div>
              <div id="card-errors" class="mt-2 red--text" role="alert"></div>
            </v-card-text>

            <v-card-actions>
              <v-btn
                id="submit"
                block
                x-large
                color="primary"
                :disabled="!valid"
                @click.stop="makePayment"
                :loading="processingPayment"
              >Pay £ {{parseFloat(orderTotal).toFixed(2)}}</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
// import BillingInfoForm from "@/components/auth/DeliveryInfoForm.vue"
import checkPostCode from "@/util/validation/postcode.js";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  data: () => {
    return {
      valid: false,
      required(fieldName) {
        return v => (v && v.length > 0) || `${fieldName} Required`;
      },
      isPostCode: val => {
        return checkPostCode(val);
      },
      address: {
        line1: "",
        line2: "",
        city: "",
        postal_code: "",
        country: "GB"
      },
      stripe: "",
      card: "",
      error: false,
      errorMessage: "",
      sameAddress: false,
      processingPayment: false
    };
  },
  watch: {
    sameAddress(val) {
      if (val == true) {
        this.populateAddress();
      } else {
        this.resetAddress();
      }
    }
  },
  computed: {
    ...mapGetters([
      "retrieveStripeClientKey",
      "retrieveUser",
      "retrieveCustomerAddress",
      "retrieveOrderBeingPaidFor"
    ]),
    tdId() {
      if (this.retrieveOrderBeingPaidFor) {
        return this.retrieveOrderBeingPaidFor.orderId;
      }
    },
    orderTotal() {
      if (this.retrieveOrderBeingPaidFor) {
        return this.retrieveOrderBeingPaidFor.orderAmount;
      }
    }
  },
  methods: {
    ...mapActions([
      "orderBeingPaidForAction",
      "stripePaymentIntentAction",
      "clearOrderBeingPaidFor",
      "stripeConfirmCardPayment"
    ]),
    populateAddress() {
      this.address.line1 = this.retrieveCustomerAddress.address_line_1;
      this.address.line2 = this.retrieveCustomerAddress.address_line_2;
      let city = "";
      if (this.retrieveCustomerAddress.address_line_3 != "") {
          city =  this.retrieveCustomerAddress.address_line_3        
      }
      if (this.retrieveCustomerAddress.address_line_4!= "") {
          if (city !="") {
            city = city + " , "+this.retrieveCustomerAddress.address_line_4
          } else {
            city = this.retrieveCustomerAddress.address_line_4 
          }
      }
      this.address.city = city
      this.address.postal_code = this.retrieveCustomerAddress.postcode;
    },
    resetAddress() {
      this.address.line1 = "";
      this.address.line2 = "";
      this.address.city = "";
      this.address.postal_code = "";
    },
    makePayment() {
      if (this.valid) {
        this.processingPayment = true;
        this.error = false;
        this.errorMessage = "";
        const rec = Object.assign(
          {},
          { userId: this.retrieveUser.userNum },
          { sessionKey: this.retrieveUser.sessionKey },
          { transaction_details_id: this.tdId },
          { address1: this.address.line1 },
          { address2: this.address.line2 },
          { city: this.address.city },
          { postal_code: this.address.postal_code }
        );
        this.stripePaymentIntentAction(rec).then(response => {
          if (response.success == true && response.clientSecret) {
            console.log("success from intent side");
            this.stripe
              .confirmCardPayment(response.clientSecret, {
                payment_method: {
                  card: this.card,
                  billing_details: {
                    address: this.address,
                    email: null,
                    name: this.retrieveUser.username,
                    phone: this.retrieveCustomerAddress.telephone_no
                  }
                }
              })
              .then(response => {
                if (response.error) {
                  console.log("Error processing payment");
                  this.processingPayment = false;
                  this.error = true;
                  this.errorMessage = response.error.message;
                } else {
                  if (response.paymentIntent.status === "succeeded") {
                    //handle post successful payment redirects and commits
                    const para = Object.assign(
                      {},
                      { userId: this.retrieveUser.userNum },
                      { sessionKey: this.retrieveUser.sessionKey },
                      { transaction_details_id: this.tdId },
                      { payment_intent_id: response.paymentIntent.id },
                      { amount: response.paymentIntent.amount }
                    );
                    this.stripeConfirmCardPayment(para).then(response => {
                      console.log(response);
                    });
                    this.$router.push({
                      name: "PaymentSuccess",
                      params: {
                        td_id: this.tdId,
                        payment_ref: response.paymentIntent.id
                      }
                    });
                    this.clearOrderBeingPaidFor();
                  }
                }
              });
          } else {
            console.log("problem with intent seting up");
            this.error = true;
            this.errorMessage = response.message;
          }
        });
      }
    },
    loadStripe() {
      this.stripe = Stripe(this.$store.state.configs.stripe_client_key);
      this.card = this.stripe.elements().create("card", {
        hidePostalCode: true
      });
      this.card.mount("#card-element");
      this.card.addEventListener("change", ({ error }) => {
        const displayError = document.getElementById("card-errors");
        this.error = "";
        this.errorMessage = "";
        if (error) {
          displayError.textContent = error.message;
          this.valid = false;
        } else {
          displayError.textContent = "";
          this.valid = true;
        }
      });
      console.log("Loading Stripe ...");
    }
  },
  activated() {
    this.loadStripe();
    this.processingPayment = false;
  },
  deactivated() {
    this.clearOrderBeingPaidFor();
  }
};
</script>